"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const WidgetState_1 = require("../Model/WidgetState");
/**
 * Factory for widget state.
 */
class WidgetStateFactory {
    /**
     * Constructor of widget state factory.
     *
     * @param {ExtendableProvider} extendableManager
     * @param {ContainerAwareFactory} containerAwareFactory
     */
    constructor(extendableManager, containerAwareFactory) {
        this.extendableManager = extendableManager;
        this.containerAwareFactory = containerAwareFactory;
    }
    /**
     * Creates new widget state.
     *
     * @return {WidgetState}
     */
    create() {
        const widgetStateClass = this.extendableManager.getExtended(WidgetState_1.WidgetState);
        return this.containerAwareFactory.create(widgetStateClass);
    }
}
exports.default = WidgetStateFactory;
